/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const checkoutTitleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-md)',
	fontWeight: 800,
	marginBottom: '10px',
};

export const checkoutDescriptionSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-small)',
	color: '#313131',
	marginBottom: '20px',
};
